import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, SubmissionError } from 'redux-form';
import browserHistory from 'react-router/lib/browserHistory';
import cx from 'classnames';

// styles
import * as styles from './RealtorLandingPublishForm.scss';

import InputField from '../../components/Company/CompanyContactUs/CompanyField/CompanyField';
import CloudflareCaptcha from '../../components/CloudflareCaptcha/CloudflareCaptcha';
import { required } from '../../helpers/reduxFormValidators';

import appendLocale from '../../helpers/appendLocale';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';

class RealtorLandingPublishFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
      params: {},
      captcha: null,
      showCaptcha: false
    };
  }

  componentWillReceiveProps({ contactUs, isMessageModalOpen }) {
    const stateModifier = {};
    const translate = this.props.translate('contactUsPage');

    if (contactUs.loading !== this.props.contactUs.loading) {
      stateModifier.sending = contactUs.loading;
    }

    if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && this.state.params.email) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageWrapper}>
            <div className={styles.contentMessage}>
              <p className={styles.title}>
                {translate('modalFeedback', 'title')}
              </p>
              <div>
                <p>
                  {translate('modalFeedback', 'weWillContact')}
                </p>
                <p>
                  {translate('modalFeedback', 'messageNotification')}
                </p>
              </div>
              <button
                className={styles.primary}
                onClick={this.props.hideMessageModal}
              >
                {translate('modalFeedback', 'textButton')}
              </button>
            </div>
          </div>
        ),
        isCloseButtonInvisible: true
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (contactUs.loaded && contactUs.loaded !== this.props.contactUs.loaded && !this.state.params.email) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageWrapper}>
            <div className={styles.contentMessage}>
              <p className={styles.title}>
                {translate('modalFeedback', 'title')}
              </p>
              <div>
                <p>
                  {translate('modalFeedback', 'weWillContact')}
                </p>
                <p>
                  {translate('modalFeedback', 'notificationWithoutMessage')}
                </p>
              </div>
              <button
                className={styles.primary}
                onClick={this.props.hideMessageModal}
              >
                {translate('modalFeedback', 'textButton')}
              </button>
            </div>
          </div>
        ),
        isCloseButtonInvisible: true
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (contactUs.error && contactUs.error !== this.props.contactUs.error) {
      this.props.openMessageModal({
        message: (
          <div className={styles.contentMessageError}>
            <div className="contentMessage">
              <div>
                <p>{translate('error')}</p>
                <button
                  className="btn btn-primary"
                  onClick={this.props.hideMessageModal}
                >
                  {translate('ok')}
                </button>
              </div>
            </div>
          </div>
        )
      });

      this.props.handleRequest && this.props.handleRequest();
    }

    if (!isMessageModalOpen && contactUs.loaded && this.props.isMessageModalOpen) {
      this.props.reset();
      browserHistory.push(appendLocale(this.props.locale, '/'));
    }

    if (Object.keys(stateModifier).length) {
      this.setState(stateModifier);
    }
  }

  submitForm = (values) => {
      const { name, email, phone_number, message, company_name } = values;
      const { captcha } = this.state;
      const params = {
        name,
        captcha,
        email: email && email.toLowerCase(),
        phone: phone_number,
        company_name,
        ...(this.props.userData && this.props.userData.id) ? { user_id: this.props.userData.id } : {}
      };
      this.setState({ params });

      if (captcha) {
        this.props.sendContactUsForm({
          data: params,
          isRealtor: true
        });
      }
  };

  handleShowCaptcha = () => {
    this.setState({ showCaptcha: true });
  }

  fetchReCaptchaToken = (token) => {
    this.setState({ captcha: token });
  }

  handleSubmit = (evt) => {
    this.props.handleSubmit(this.submitForm)(evt);
    return true;
  };

  renderOption = (item) => ({
    id: item,
    label: `${this.props.translate('contactUsPage', 'userDetailsSection', item)}`
  });

  render() {
    const { translate } = this.props;
    const contactUsTranslate = translate('contactUsPage', 'userDetailsSection');

    return (
      <div className={styles.wrapper}>
        <div className={styles.titleWripper}>
          <p className={styles.title}>
            {contactUsTranslate('publishTitle')}
          </p>
          <p>
            {contactUsTranslate('publishTitleInfo')}
          </p>
        </div>
        <form onFocus={this.handleShowCaptcha} onSubmit={this.handleSubmit}>
          <div className={styles.inputsBlock}>
            <div className={styles.inputWrapper}>
                <Field
                  name="name"
                  component={InputField}
                  type="text"
                  validate={[required]}
                  placeholder={`${contactUsTranslate('nameTitle')} *`}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
              <div className={styles.inputWrapper}>
                <Field
                  name="phone_number"
                  component={InputField}
                  type="text"
                  validate={[required]}
                  placeholder={`${contactUsTranslate('phoneTitle')} *`}
                  translateForError={translate('errorFieldMessages')}
                  isRtl={this.props.isRtl}
                />
              </div>
          </div>
          <div className={styles.inputsBlock}>
            <div className={styles.inputWrapper}>
              <Field
                name="email"
                component={InputField}
                type="text"
                placeholder={contactUsTranslate('emailTitle')}
                translateForError={translate('errorFieldMessages')}
                isRtl={this.props.isRtl}
              />
            </div>
            <div className={styles.inputWrapper}>
              <Field
                name="company_name"
                component={InputField}
                type="text"
                placeholder={contactUsTranslate('companyName')}
                translateForError={translate('errorFieldMessages')}
                isRtl={this.props.isRtl}
              />
            </div>
          </div>
          <div className={styles.submitWrapper}>
            <div className={styles.submitBlock}>
                {this.state.showCaptcha && (
                  <CloudflareCaptcha
                    action={CAPTCHA_ACTIONS.CONTACT_US_REALTOR}
                    doReset={this.props.contactUs.loaded}
                    fetchToken={this.fetchReCaptchaToken}
                  />)
                }
                <button
                  type="submit"
                  className={cx('btn btn-primary', styles.button)}
                  disabled={this.state.sending || !this.state.captcha}
                >
                  {
                    (this.state.sending)
                      ? (<span className="icon icon-om-spinner om-pulse" />)
                      : this.props.translate('contactUsPage', 'messageSection', 'submitForDetails')
                  }
                </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

RealtorLandingPublishFormComponent.propTypes = {
  inModal: PropTypes.bool,
  handleRequest: PropTypes.func,
  translate: PropTypes.func,
  reset: PropTypes.func,
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  sendContactUsForm: PropTypes.func,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  locale: PropTypes.string,
  userData: PropTypes.object,
  contactUs: PropTypes.object,
  isMessageModalOpen: PropTypes.bool,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func
};

export default RealtorLandingPublishFormComponent;
